import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8f408876"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-mask" }
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-container" }
const _hoisted_4 = { class: "modal-icon" }
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "modal-body" }
const _hoisted_9 = { class: "modal-footer mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InfoIcon = _resolveComponent("InfoIcon")!
  const _component_CheckIcon = _resolveComponent("CheckIcon")!
  const _component_AsahiTypography = _resolveComponent("AsahiTypography")!
  const _component_AsahiButton = _resolveComponent("AsahiButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.isErrorModal)
            ? (_openBlock(), _createBlock(_component_InfoIcon, { key: 0 }))
            : (_openBlock(), _createBlock(_component_CheckIcon, { key: 1 }))
        ]),
        _createElementVNode("div", _hoisted_5, [
          _renderSlot(_ctx.$slots, "header", {}, () => [
            _createVNode(_component_AsahiTypography, { type: "headline-medium" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t(_ctx.message)), 1)
              ]),
              _: 1
            })
          ], true)
        ]),
        (_ctx.headerSubMsg)
          ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
              _createTextVNode(_toDisplayString(_ctx.$t(_ctx.headerSubMsg)) + " ", 1),
              (_ctx.hyperLink)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: _ctx.hyperLink,
                    target: "_self",
                    color: "tertiary"
                  }, _toDisplayString(_ctx.hyperLinkText), 9, _hoisted_7))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_8, [
          _renderSlot(_ctx.$slots, "body", {}, () => [
            _createVNode(_component_AsahiTypography, {
              type: _ctx.headerSubMsg? 'headline-small': 'headline-2'
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t(_ctx.subMessage)), 1)
              ]),
              _: 1
            }, 8, ["type"])
          ], true)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _renderSlot(_ctx.$slots, "footer", {}, () => [
            (_ctx.showButton)
              ? (_openBlock(), _createBlock(_component_AsahiButton, {
                  key: 0,
                  indent: "2",
                  color: "secondary-red",
                  class: "products-button",
                  onClick: _ctx.close
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t(_ctx.buttonText)), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ], true)
        ])
      ])
    ])
  ]))
}